<template>
  <CContainer class="col-md-5 login-right">
    <CRow class="h-50">
      <CCol class="login-right__image"></CCol>
    </CRow>
    <CRow class="h-50">
      <CCol class="login-right__text">
          <h4 class="text-justify">
            <span v-html="description"/>
            <CLink class="text-white" :href="`mailto:${contactEmail}`">{{ contactEmail }}</CLink>
          </h4>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import loginTranslations from "../constants/loginTranslations";

export default {
  name: "LoginRight",
  methods: {
    getDescription() {
      return this.$store.state.language === 'fr' ? loginTranslations.fr.description : loginTranslations.en.description;
    },
  },
  data: function () {
    return {
      contactEmail: "gareat-mazars@gareat.com",
      description: this.getDescription()
    }
  },
  watch: {
    "$store.state.language"() {
      this.description = this.getDescription()
      console.log(this.description)
    }
  }
};
</script>

<style scoped lang="scss">
.hidden-input {
  display: none;
}

.login-right {
  height: 100vh !important;
  background-color: var(--color);
  color: white;
}

.login-right__image {
  background-image: url("/img/accueil.jpeg");
  background-position: center;
  background-size: cover;
}

.login-right__text {
  padding: 25px 40px;

  h3 {
    font-size: 35px;
  }
}

@media only screen and (max-width: 767px) {
  .login-right {
    display: none;
  }
}
</style>
